import { render, staticRenderFns } from "./CommentsTotal.vue?vue&type=template&id=060a2d00&"
import script from "./CommentsTotal.vue?vue&type=script&lang=js&"
export * from "./CommentsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports